import { DESC } from 'NewAngular/constants/core.constants';
import { CustomPDFReportType } from 'CustomPDFReportsApp/ts/enums/custom-pdf-report-type.enum';
export const CUSTOM_PDF_REPORTS_LIST_DEFAULT_SORT_DIRECTIONS = { user_modify_date: DESC };
export const DELETE_CUSTOM_PDF_REPORTS_ERROR_MESSAGE = 'An error occurred while deleting the report template. Please try again or contact support.';
export const CUSTOM_PDF_REPORTS_DUPLICATE_MODAL_ERRORS = {
    404: {
        does_not_exist: 'The PDF report template you are duplicating does not exist in our database. Please try a different PDF report template.',
        permission_denied: 'You do not have access to this PDF report template.',
    },
    422: {
        blank_name: 'A PDF report template must have a name. Please add a name for the PDF report template.',
        duplicate_name: 'A PDF report template with this name exists already. Please change the name of the PDF report template.',
    },
};
export const CUSTOM_PDF_REPORTS_DUPLICATE_MODAL_DEFAULT_ERROR_MESSAGE = 'Something went wrong when trying to duplicate the PDF report template. Please try again.';
export const REPORT_TYPE_OPTIONS = [
    {
        label: '1 Security',
        value: CustomPDFReportType.AGGREGATE_SECURITY_OVERVIEW,
        checked: true,
    },
    {
        label: '2 Securities',
        value: CustomPDFReportType.AGGREGATE_SECURITY_COMPARISON,
        checked: true,
    },
    {
        label: '3+ Securities',
        value: CustomPDFReportType.MULTI_SECURITY_COMPARISON,
        checked: true,
    },
];
import { FolderableAppType } from 'FoldersApp/enums/folderable-app-type.enum';
export const PDF_FOLDERABLE_APP_CONFIG = {
    appName: 'CustomPDFReportsApp',
    folderableAppType: FolderableAppType.LIST_PAGE,
    itemNamePlural: 'Report Templates',
};
